export { useTestimonialCarousel } from "./useTestimonialCarousel";
export type { UseTestimonialCarouselOptions, UseTestimonialCarouselResult } from "./useTestimonialCarousel";
